import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"w100 centered mt20\"><span class=\"fs20 fw600\">スグIN テキスト編集</span></div><div class=\"clear mb5\"></div><p class=\"fs16 mt20 fw600\"><span class=\"fs12\"> ボタンタイトル（10文字以内）</span></p><div class=\"clear\"></div>", 4)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt20 fw600" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, " ボタンタイトル 小テキスト（15文字以内）")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", { class: "fs16 mt20 fw600" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs12" }, " 説明文（50文字以内）")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextareaTag = _resolveComponent("TextareaTag")!

  return (_ctx.rcm.room_setting)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
          _hoisted_2,
          _createVNode(_component_TextareaTag, {
            placeholder: "今すぐ相談可能です！",
            class: "fl fs18 roundForm mw100 mt5",
            style: `height:50px;`,
            value: _ctx.rcm.room_setting ? _ctx.rcm.room_setting.instant_room_button_title : ``,
            maxlength: 10,
            onInputValue: _ctx.inputButtonTitle
          }, null, 8, ["value", "onInputValue"]),
          _hoisted_6,
          _hoisted_7,
          _hoisted_8,
          _createVNode(_component_TextareaTag, {
            placeholder: "こちらからご予約ください",
            class: "fl fs14 roundForm mw100 mt5",
            style: `height:80px;`,
            value: _ctx.rcm.room_setting ? _ctx.rcm.room_setting.instant_room_button_small_text : ``,
            maxlength: 15,
            onInputValue: _ctx.inputButtonSmallText
          }, null, 8, ["value", "onInputValue"]),
          _hoisted_9,
          _hoisted_10,
          _hoisted_11,
          _createVNode(_component_TextareaTag, {
            placeholder: "最短10分でご案内できます。右のボタンよりフォームに回答後、お待ち下さい。",
            class: "fl fs14 roundForm mw100 mt5",
            style: `height:80px;`,
            value: _ctx.rcm.room_setting ? _ctx.rcm.room_setting.instant_room_description : ``,
            maxlength: 50,
            onInputValue: _ctx.inputDescription
          }, null, 8, ["value", "onInputValue"])
        ])
      ]))
    : _createCommentVNode("", true)
}